<template>
    <transition name="cookie-fade">
        <div v-if="isVisible" class="cookie-consent-bar py-3 px-4 shadow-lg">
            <div class="container d-flex flex-column flex-md-row align-items-center justify-content-between">
                <div class="cookie-text mb-3 mb-md-0 mr-md-4">
                    <div class="d-flex align-items-center mb-1">
                        <i class="bi bi-shield-lock-fill text-warning mr-2"></i>
                        <span class="font-weight-bold">Cookie & Privacy Preferences</span>
                    </div>
                    <div class="small text-muted">
                        We use essential cookies to maintain your authenticated session and workspace preferences. 
                        No invasive third-party tracking or ad profiling cookies are used. 
                        Read our 
                        <a href="#" @click.prevent="openLegal('privacy')" class="text-primary font-weight-bold text-decoration-none">
                            Privacy Policy
                        </a> 
                        for more details.
                    </div>
                </div>
                <div class="cookie-actions d-flex align-items-center flex-nowrap">
                    <b-button
                        size="sm"
                        variant="outline-secondary"
                        class="mr-2 text-nowrap"
                        @click="acceptEssential"
                    >
                        Essential Only
                    </b-button>
                    <b-button
                        size="sm"
                        variant="primary"
                        class="text-nowrap"
                        @click="acceptAll"
                    >
                        Accept All
                    </b-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { BButton } from 'bootstrap-vue';
    import eventBus from '../event-bus';

    const STORAGE_KEY = 'vt_cookie_consent';

    export default {
        name: 'CookieConsent',
        components: {
            BButton
        },
        data() {
            return {
                isVisible: false
            };
        },
        mounted() {
            this.checkConsent();
        },
        methods: {
            checkConsent() {
                try {
                    const consent = localStorage.getItem(STORAGE_KEY);
                    if (!consent) {
                        this.isVisible = true;
                    }
                } catch (e) {
                    this.isVisible = false;
                }
            },
            acceptAll() {
                try {
                    localStorage.setItem(STORAGE_KEY, 'all');
                } catch (e) {
                    // ignore storage errors
                }
                this.isVisible = false;
                this.$emit('consent-updated', 'all');
            },
            acceptEssential() {
                try {
                    localStorage.setItem(STORAGE_KEY, 'essential');
                } catch (e) {
                    // ignore storage errors
                }
                this.isVisible = false;
                this.$emit('consent-updated', 'essential');
            },
            openLegal(tab) {
                eventBus.$emit('open-legal', tab);
                this.$emit('open-legal', tab);
            }
        }
    };
</script>

<style scoped>
    .cookie-consent-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1030;
        background-color: #ffffff;
        border-top: 1px solid rgba(0, 0, 0, 0.12);
        color: #1e293b;
    }

    [data-theme="dark"] .cookie-consent-bar {
        background-color: #1e293b;
        border-top-color: #334155;
        color: #f1f5f9;
    }

    [data-theme="dark"] .cookie-consent-bar .text-muted {
        color: #94a3b8 !important;
    }

    .cookie-text {
        font-size: 0.88rem;
        line-height: 1.45;
    }

    .cookie-fade-enter-active, .cookie-fade-leave-active {
        transition: transform 0.3s ease, opacity 0.3s ease;
    }

    .cookie-fade-enter, .cookie-fade-leave-to {
        transform: translateY(100%);
        opacity: 0;
    }
</style>
